export const PRODUCT_REVIEW_STATUS_REJECTED = -1
export const PRODUCT_REVIEW_STATUS_AWAITING_MODERATION = 0
export const PRODUCT_REVIEW_STATUS_PASSED_MODERATION = 1
